import React, { useState } from 'react';

import { Scrollchor, AnimateConfig, easeOutQuad } from 'react-scrollchor';

import IZRULogo from '@assets/images/iz-ru-logo.svg';
import IZRULogoBlack from '@assets/images/iz-ru-logo-black.png';

import facebook from '@assets/images/social/facebook.svg';
import twitter from '@assets/images/social/twitter.svg';
import vk from '@assets/images/social/vk.svg';

import menuMobile from '@assets/images/menu-mobile.svg';
import menuMobileClose from '@assets/images/menu-mobile-close.svg';

const defaultAnimate: AnimateConfig = {
  offset: 124,
  duration: 600,
  easing: easeOutQuad,
};

type PageMenuProps = {
  isDesktopOrLaptop?: any;
};

export const PageMenu: React.FC<PageMenuProps> = ({ isDesktopOrLaptop }) => {
  const [show, changeShow] = useState(false);

  const clickChangeShow = () =>
    changeShow(!show);

  return (
    <header
      className="
        fixed
        top-0
        left-0
        right-0
        z-40
        mb-8
        bg-smGrayText
      "
    >
      <div
        className="
          flex
          justify-between
          items-center
          pt-5
          pb-2.5
          lg:py-7.5
          px-5
          lg:px-0
          m-auto
          w-full
          max-w-1160
        "
      >
        <a className="flex flex-col lg:flex-row lg:items-center lg:-mt-1" href="https://iz.ru">
          <img
            className="max-w-28 max-h-29 lg:max-w-46 lg:max-h-48 -mb-1 lg:-mb-0"
            src={IZRULogo}
            width={isDesktopOrLaptop ? "149" : "99" }
            height={isDesktopOrLaptop ? "32" : "29" }
            alt=""
          />
          <span className="text-xxs lg:text-md text-white mt-2 lg:mt-0 lg:ml-6">
            Специальный проект
          </span>
        </a>
        <div
          className={`
            fixed
            h-full
            overflow-hidden
            lg:overflow-visible
            lg:h-auto
            top-0
            w-full
            lg:w-auto
            right-0
            lg:right-auto
            lg:relative
            z-20
            lg:z-auto
            transition
            delay-150
            duration-300
            transform
            lg:transform-none
            ${show ? ` translate-x-0` : ` translate-x-full`}
          `}
        >
          <div
            style={{ backgroundColor: show ? 'rgba(0, 0, 0, 0.75)' : 'rgba(0, 0, 0, 0.0)' }}
            className={`
              block
              lg:hidden
              absolute
              right-0
              top-0
              left-0
              bottom-0
              z-10
              transition
              transform
              duration-300
            `}
          />
          <div
            className="
              w-5/6
              lg:w-auto
              absolute
              lg:relative
              right-0
              top-0
              h-full
              flex
              flex-col
              lg:flex-row
              flex-auto
              justify-start
              py-6
              px-6
              lg:py-0
              lg:px-0
              bg-white
              transition
              lg:bg-transparent
              z-20
            "
          >
            <div className="flex flex-col lg:hidden justify-between mb-8">
              <a className="flex items-center -mt-1" href="https://iz.ru">
                <img
                  className="max-w-28 max-h-29 lg:max-w-46 lg:max-h-48 -mb-1 lg:-mb-0"
                  src={IZRULogoBlack}
                  width="99"
                  height="29"
                  alt=""
                />
              </a>
              <span className="text-xxs lg:text-md text-blackText mt-2 lg:mt-0 lg:ml-6">
                Специальный проект
              </span>
            </div>
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: -124 }}
              className="ml-0 lg:ml-12 py-2.5 lg:py-0 text-blackText lg:text-white hover:text-red-400"
              to="#main"
            >Главная</Scrollchor>
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: -110 }}
              className="ml-0 lg:ml-9 py-2.5 lg:py-0 text-blackText lg:text-white hover:text-red-400"
              to="#virus"
            >Происхождение вируса</Scrollchor>
            <Scrollchor
              animate={{ duration: 1500, easing: easeOutQuad, offset: -110 }}
              className="ml-0 lg:ml-9 py-2.5 lg:py-0 text-blackText lg:text-white hover:text-red-400"
              to="#interview"
            >Полное интервью</Scrollchor>
            {/* <a href="">Интерактивная карта</a> */}
          </div>
        </div>
        <span
          onClick={clickChangeShow}
          className="
            absolute
            lg:hidden
            z-20
            right-0
            top-0
            w-16
            h-16
            justify-center
            items-center
            cursor-pointer
            flex
            lg:mt-0.5
          "
        >
          {show ?
            <img
              src={menuMobileClose}
              width="18"
              height="18"
              alt=""
            />
            :
            <img
              src={menuMobile}
              width="18"
              height="18"
              alt=""
            />
          }
        </span>
        <div className="hidden lg:flex items-center mt-0.5">
          <a className="ml-0 lg:ml-7 transition hover:opacity-50" target="_blank" rel="noreferrer" href="http://facebook.com/izvestia.ru">
            <img src={facebook} width="10" height="19" alt="" />
          </a>
          <a className="ml-7 transition hover:opacity-50" target="_blank" rel="noreferrer" href="https://vk.com/izvestia">
            <img src={twitter} width="20" height="16" alt="" />
          </a>
          <a className="ml-7 transition hover:opacity-50" target="_blank" rel="noreferrer" href="https://twitter.com/izvestia_ru">
            <img src={vk} width="25" height="14" alt="" />
          </a>
        </div>
      </div>
    </header>
  );
}